var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"project-list-item"},[_c('router-link',{staticClass:"in",attrs:{"to":'/portfolio/' + this.projectId}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }